import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { components } from 'react-select';

const _excluded = ["selectProps", "innerRef", "children"];
const {
  Menu: CoreMenu
} = components;
const Menu = _ref => {
  let {
      selectProps,
      innerRef,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CoreMenu, _extends({}, rest, {
    innerRef: el => {
      innerRef.current = el;
      selectProps.menuRef.current = el;
    },
    selectProps: selectProps
  }), children);
};

export default Menu;
